var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.0001C15.5005 12.2627 15.449 12.5229 15.3486 12.7655C15.2483 13.0082 15.1009 13.2286 14.915 13.4141L9.62103 18.7071L8.20703 17.2931L13.5 12.0001L8.20703 6.70714L9.62103 5.29314L14.914 10.5861C15.1001 10.7716 15.2476 10.992 15.3482 11.2346C15.4488 11.4773 15.5004 11.7375 15.5 12.0001Z",
    fill: "#696969"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownRight);
export default __webpack_public_path__ + "static/media/dropdown-right.fa44e061d8dd4b8399c8a64cfafe9783.svg";
export { ForwardRef as ReactComponent };